// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.signature-pad[data-v-156f7784] {\n  width: 100%;\n  max-height: 100px;\n  min-width: 100px;\n  min-height: 50px;\n  border-bottom: 1px solid #ccc;\n  cursor: pointer;\n  position: relative; /* Ensure the signature image is positioned correctly */\n}\n", ""]);
// Exports
module.exports = exports;
